<template>
  <div class="smile-box">
    <a href="https://a.app.qq.com/dom/micro/open.jsp?pkgname=com.noahyijie.ygb" class="alert-btn" />
    <img
      src="../../assets/images/close.png"
      class="alert-close"
      @click="$emit('close-modal')"
    />
  </div>
</template>

<script>
export default {
  name: "smile-success"
}
</script>

<style lang="less" scoped>
.mobile {
  .modal-wrapper {
    .smile-box {
      width: 6.7rem;
      height: 8.3rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      box-sizing: border-box;
      border-radius: 0.2rem;
      background-size: 100% !important;
      background: url("../../assets/images/smileSuccessBg.png") no-repeat;
      .alert-btn {
        width: 5.7rem;
        height: 0.9rem;
        position: absolute;
        left: 0.5rem;
        bottom: 1.1rem;
      }
      .alert-close {
        position: absolute;
        width: 0.54rem;
        left: 50%;
        transform: translateX(-50%);
        bottom: -0.79rem;
      }
    }
  }
}
.pc {
  .modal-wrapper {
    .smile-box {
      width: 5.06rem;
      height: 6.3rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      box-sizing: border-box;
      border-radius: 0.2rem;
      background-size: 100% !important;
      background: url("../../assets/images/smileSuccessBg.png") no-repeat;
      .alert-btn {
        width: 4.35rem;
        height: 0.68rem;
        position: absolute;
        left: 0.35rem;
        bottom: 0.85rem;
      }
      .alert-close {
        position: absolute;
        width: 0.54rem;
        left: 50%;
        transform: translateX(-50%);
        bottom: -0.79rem;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resultModal/smile-success.vue